<router-outlet></router-outlet>
<p-toast [style]="{'width':'27rem'}"></p-toast>
<app-loader [ngClass]="{'d-none': !common.loader}"></app-loader>
